document.addEventListener('DOMContentLoaded',function(){
 const builder=document.querySelector('[data-gp-builder]');if(!builder)return;
 const fields=[...builder.querySelectorAll('[data-gp-builder-part]')];
 const list=builder.querySelector('[data-gp-builder-summary]'),total=builder.querySelector('[data-gp-builder-total]');
 function getParts(){return fields.filter(f=>f.value).map(f=>{const o=f.selectedOptions[0];return {category:f.dataset.category,title:o.textContent.trim(),price:Number(o.dataset.price||0),url:o.dataset.url,variant:f.value}})}
 function update(){const parts=getParts();list.replaceChildren();if(!parts.length){const li=document.createElement('li');li.textContent='No components selected yet.';list.append(li)}
  for(const p of parts){const li=document.createElement('li');li.textContent=p.category+': '+p.title;list.append(li)}
  total.textContent=parts.reduce((n,p)=>n+p.price,0).toFixed(3)+' BHD';
  const amdCPU=parts.some(p=>p.category==='CPU · AMD Ryzen');
  const intelCPU=parts.some(p=>p.category==='CPU · Intel');
  const amdBoard=parts.some(p=>p.category==='Motherboard · AMD');
  const intelBoard=parts.some(p=>p.category==='Motherboard · Intel');
  const mismatch=(amdCPU&&intelBoard)||(intelCPU&&amdBoard);
  const status=builder.querySelector('[data-gp-builder-compat]');
  const quote=builder.querySelector('[data-gp-builder-enquire]');
  if(status)status.textContent=mismatch?'CPU and motherboard families conflict. Choose matching AMD/Intel parts before requesting a quotation.':'Final socket, RAM generation, wattage and physical compatibility require Gamers Point review.';
  if(quote)quote.disabled=mismatch;

 }
 fields.forEach(f=>f.addEventListener('change',()=>{
   if(f.value&&(f.dataset.category.startsWith('CPU ·')||f.dataset.category.startsWith('Motherboard ·'))){
     const group=f.dataset.category.startsWith('CPU ·')?'CPU ·':'Motherboard ·';
     fields.filter(other=>other!==f&&other.dataset.category.startsWith(group)).forEach(other=>{other.value=''});
   }
   update();
 }));
 builder.querySelector('[data-gp-builder-enquire]').addEventListener('click',()=>{
  const parts=getParts();if(!parts.length){alert('Please choose at least one component.');return}
  const estimated=parts.reduce((n,p)=>n+p.price,0).toFixed(3);
  const msg='Hello Gamers Point, I would like a custom PC quotation and technical compatibility check.\n\n'+parts.map(p=>p.category+': '+p.title+'\n'+location.origin+p.url).join('\n\n')+'\n\nSelected parts estimate: '+estimated+' BHD. Please confirm compatibility, complete build cost, warranty, stock and delivery.';
  window.open('https://wa.me/97336820393?text='+encodeURIComponent(msg),'_blank','noopener');
 });
 update();
});